/* @flow */

import * as types from 'src/shared/app/market/action/marketActionTypes';
import {
  createReducer,
  setRequestResult,
  setFetchingState,
  unsetFetchingState,
} from 'src/shared/core/util/reducerUtils';

const initialState = {
  result: null,
  isFetching: false,
};

export default createReducer(initialState, {
  [types.FETCH_FEATURED_FILTERS_REQUEST]: setFetchingState,
  [types.FETCH_FEATURED_FILTERS_SUCCESS]: setRequestResult,
  [types.FETCH_FEATURED_FILTERS_FAILURE]: unsetFetchingState,
});
